module.exports = __webpack_public_path__ + "img/desc--white.ebc5baa1.svg";